import { render, staticRenderFns } from "./OfficerOpenRecruitmentPostList.vue?vue&type=template&id=cb6c7e3e&scoped=true&"
import script from "./OfficerOpenRecruitmentPostList.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentPostList.vue?vue&type=script&lang=js&"
import style0 from "./OfficerOpenRecruitmentPostList.vue?vue&type=style&index=0&id=cb6c7e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6c7e3e",
  null
  
)

export default component.exports